'use strict';

/**
 * Nonexitent share view
 *
 * @category   View
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColioItemView = require('base/Colido.ItemView');
var template = require('../../templates/layout/empty-share.hbs');

var EmptyShareView = ColioItemView.extend({
    template: template,
    className: 'share-empty',
});

module.exports = EmptyShareView;